import gql from 'graphql-tag'

export const API_KEY_GENERATE = gql`
    mutation apiKeyGenerate($websiteID: ID!) {
        apiKeyGenerate(websiteID: $websiteID)
    }
`

export const API_KEY_REVOKE = gql`
    mutation apiKeyRevoke($websiteID: ID!) {
        apiKeyRevoke(websiteID: $websiteID)
    }
`
